import * as actionType from './types';
import axios from '../../../common/config/axios';

export const getList = (props) => dispatch => {
  axios.get('betting_history/list', {params: props})
  .then(function (response) {
    dispatch ({
      type: actionType.BETTINGHISTORY_LIST,
      value: response.data
    });
  })
  .catch(err => {
    
  });
};

export const cancelWithdraw = (data) => dispatch => {
  axios.post('betting_history/cancel', data)
  .then(function (response) {
    dispatch ({
      type: actionType.BETTINGHISTORY_CANCEL,
      value: response.data
    });
  })
  .catch(err => {
    
  });
};

/*  export const getDropDown = (data) => (dispatch, getState) => {
  console.log(data)
  axios
      .get("betting_history/drop_down",{params: data})
      .then((res) => {
          dispatch({
              type: actionType.BETTINGHISTORY_DROPDOWN,
              value: res.data,
          });
      })
      .catch((err) => {
          console.log("Get Agent Downline Error", err);
      });
};  */

export const getDropDown = (payload = {}) => (dispatch, getState) => {
  const state = getState();
  const user = state.currentUser?.data || {};
  const id = payload.id ?? user.id ?? user.aid ?? user.agent_id;
  const merchant_id = payload.merchant_id ?? user.merchant_id ?? user.merchantId;

  if (!id || !merchant_id) {
    console.warn('Missing id/merchant_id for drop_down', { id, merchant_id });
    return Promise.resolve();
  }

  return axios
    .get('betting_history/drop_down', { params: { id, merchant_id } })
    .then((res) => {
      dispatch({ type: actionType.BETTINGHISTORY_DROPDOWN, value: res.data });
      return res;
    })
    .catch((err) => {
      dispatch({ type: actionType.BETTINGHISTORY_DROPDOWN, value: err?.response?.data || err.message });
      throw err;
    });
};


export const fetchUserBasicsFromLocal = () => (dispatch) => {
  const raw = localStorage.getItem('username');
  let username = raw;

  // if you store a JSON object in localStorage under "user"
  try {
    if (raw && raw.startsWith('{')) {
      const parsed = JSON.parse(raw);
      username = parsed?.username;
    }
  } catch (_) {}

  if (!username) return Promise.resolve();

  return axios
    .get('betting_history/get_info_by_username', { params: { username } })
    .then((res) => {
      dispatch({ type: actionType.SET_USER_BASICS, value: res.data.data });
      return res;
    })
    .catch((err) => {
      console.error('fetchUserBasicsFromLocal error', err?.response?.data || err.message);
      dispatch({ type: actionType.SET_USER_BASICS_FAIL, value: err?.response?.data || err.message });
      return Promise.resolve();
    });
};

 
